// extracted by mini-css-extract-plugin
module.exports = {"infoIcon":"InfoBubble_infoIcon__DwM06","modalContainer":"InfoBubble_modalContainer__XaIS5","modalBody":"InfoBubble_modalBody__2vOdP"};